import { IOT_GATEWAY_SERVICE_URL, MQTT_URL } from "../../../Utils/constService";
import api from "../../../../BasicComponent/Service/api";

export const fetchMqtt = (params) => {
  return api.get(IOT_GATEWAY_SERVICE_URL, {
    params,
  });
};

export const postMqtt = (data) => {
  return api.post(IOT_GATEWAY_SERVICE_URL, data);
};

export const putMqtt = (data, mqttId) => {
  return api.put(`${IOT_GATEWAY_SERVICE_URL}/${mqttId}`, data);
};

export const deleteMqtt = (mqttId) => {
  return api.delete(`${IOT_GATEWAY_SERVICE_URL}/${mqttId}`);
};
export const subscribeMqtt = (uuid, resumeAssets) =>
  api.post(`${MQTT_URL}/subscribe/${uuid}?resumeAssets=${resumeAssets}`);

export const unSubscribeMqtt = (uuid) =>
  api.post(`${MQTT_URL}/unsubscribe/${uuid}`);

export const connectMqtt = (uuid) => api.post(`${MQTT_URL}/connect/${uuid}`);

export const disConnectMqtt = (uuid) =>
  api.post(`${MQTT_URL}/disconnect/${uuid}`);
